import "react-app-polyfill/ie9"
import "react-app-polyfill/stable"
import "intersection-observer"

import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import { initialize } from "./modules/GoogleAnalytics"
import { HackleProvider, getUserId } from "@hackler/react-sdk"
import { deviceIdMigration } from "./modules/User"
import dotenv from "dotenv"
import { Locale } from "./locale"
import { hackleClient } from "./hackleClient"

dotenv.config()

initialize("UA-176416098-1")

deviceIdMigration()

window.onerror = function (msg, url, line, col, error) {
  hackleClient.onReady(() => {
    hackleClient.track({
      key: "homepage_error",
      properties: {
        errorCode: 500,
        errorType: "script",
        errorMessage: error?.message ?? "",
        col: col ?? "",
        line: line ?? "",
        url: url ?? "",
      },
    })
  })
}

ReactDOM.render(
  <React.StrictMode>
    <HackleProvider
      hackleClient={hackleClient}
      user={{
        id: getUserId(),
        properties: { locale: Locale.getLangCode(), timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone },
      }}>
      <App />
    </HackleProvider>
  </React.StrictMode>,
  document.getElementById("root")
)
